import React from 'react';
import Video from 'components/Video';
import Image from 'components/Image';

const MultiMediaBlock = ({ mediaEl }) => {
	if (mediaEl.file.contentType === 'video/mp4') {
		return (
			<Video autoPlay muted loop playsInline src={mediaEl.file.url}>
				<video autoPlay muted loop playsInline src={mediaEl.file.url} />
			</Video>
		);
	} else {
		return (
			<Image
				style={{
					position: 'absolute'
				}}
				height={['100%']}
				fluid={mediaEl.fluid}
			/>
		);
	}
};

export default MultiMediaBlock;
